import { render, staticRenderFns } from "./ListFormasPagamentos.vue?vue&type=template&id=46c3d5b4&"
import script from "./ListFormasPagamentos.vue?vue&type=script&lang=js&"
export * from "./ListFormasPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports